<div #point_1 *ngIf="!modeRead" class="container">

    <h1 class="my-4 pb-3 fw-bold border-bottom border-2">
        
        اخبار و اطلاعات مرتبط با سفر 
    
    </h1>

    <div *ngIf="news.length" class="row">

        <small class="fw-bold px-3 pb-3"> نمایش {{ news.length | faNum }} از {{ news[0].iTotal | faNum }} </small>

        <div (click)="openDetail(item,i)" *ngFor="let item of news" class="col-lg-4 col-md-6">

            <div class="newsbox p-2">

                <img class="w-100" src="{{item.strImage ? 'data:image/png;base64,' + item.strImage : '../../../assets/imgs/preview__thumbnail.png' }}"  alt="{{item.strTitle}}" [title]="item.strTitle">

                <article class="px-2 newstitle" [title]="item.strTitle">

                    <h2 class="mb-1" style="font-size: 14px;height: 70px;">

                        <strong> {{ subString_Title(item.strTitle,60) }} </strong>

                    </h2>

                    <div class="w-100 text-start">

                        <small> {{ item.strDateTime | faNum}} </small>
                        
                    </div>

                </article>

            </div>

        </div>

        <!-- اسکرول لودینگ -->

        <div Infinite-Scroll [ngClass]="(bScrollLoading && !bDataEnded) ? 'infinite-scroll w-100' : '' ">

            <ng-container *ngIf="bScrollLoading && !bDataEnded">

                <div class="loader"></div>

            </ng-container>

        </div>

        <!--  -->

        <div *ngIf="!bDataEnded" class="p-5"></div>

        <!--  -->

        <div *ngIf="bDataEnded" class="row gx-2 justify-content-center align-items-center p-3">

            <div class="col-5 ps-1">

                <div class="border"></div>

            </div>

            <div class="col-1 d-flex justify-content-center align-items-center">

                <ng-container *ngIf="mdl_Search.get('tiType')?.value as tiType">

                    <mat-icon class="texr-secondary pointer" title="رفتن به بالا" (click)="gotoTop()">

                        category

                    </mat-icon>

                </ng-container>

            </div>

            <div class="col-5 pe-1">

                <div class="border"></div>

            </div>

        </div>

    </div>

</div>

<div *ngIf="modeRead" class="container">

    <div class="row newsboxdetail my-4">

        <div class="col-12 d-flex justify-content-center">

            <div class="col-12 col-md-10">

                <img class="w-100" *ngIf="newsDetail?.strImage" src="data:image/png;base64,{{newsDetail?.strImage}}"
                    style="object-fit:contain ;" alt="{{newsDetail?.strTitle}}">

                <img class="w-100" *ngIf="!newsDetail?.strImage" src="../../../assets/imgs/preview__thumbnail.png">

            </div>

        </div>

        <div class="col-12 d-flex justify-content-center pt-3">

            <div class="col-12 col-md-10">

                <h1 class="fw-bold m-0 mb-2">

                    {{newsDetail?.strTitle |faNum}}

                </h1>

                <p class="my-4" style="line-height: 27px;" [innerHTML]="(newsDetail?.strContent)"> </p>

                <small class="">

                    {{newsDetail?.strDateTime |faNum}} 

                </small>

            </div>

        </div>

    </div>

</div>